import { useEffect, useState } from 'react';
import cmsService from '../services/cmsService';
import analyticsService from '../services/analyticsService';

/** Coalesce duplicate CMS fetch / page-view calls within a short window. */
const cmsPageViewInflight = new Map();

/** CMS slug → API call that triggers backend page_view sync (see cmsController.trackPageView). */
const CMS_PAGE_TRACKERS = {
  'how-it-works': () => cmsService.getHowItWorks(),
  'how-it-works2': () => cmsService.getHowItWorks2(),
  'what-we-do': () => cmsService.getWhatWeDo(),
  'who-we-are': () => cmsService.getWhoWeAre(),
  'ways-to-fly': () => cmsService.getWaysToFly(),
  faq: () => cmsService.getFAQ(),
  'safety-and-security': () => cmsService.getSafetyAndSecurity(),
  news: () => cmsService.getNews(),
  blog: () => cmsService.getBlogs(),
  'about-us': () => cmsService.getAboutUs(),
  'contact-us': () => cmsService.getContactUs(),
  'investor-relations': () => cmsService.getInvestorRelations(),
  career: () => cmsService.getCareer(),
  'terms-and-conditions': () => cmsService.getTermsAndConditions(),
  'privacy-policy': () => cmsService.getPrivacyPolicy(),
  'cookie-policy': () => cmsService.getCookiePolicy(),
  'refund-and-cancellation': () => cmsService.getRefundAndCancellation(),
  'offer-terms': () => cmsService.getOfferTerms(),
  'home-page': () => analyticsService.recordPageView('home_page'),
};

/**
 * Record a CMS page view and return the page data from the same request.
 * Use on static pages that do not fetch CMS content through CMSPage.
 */
export default function useCMSPageViewTracking(pageType) {
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const track = CMS_PAGE_TRACKERS[pageType];
    if (!track) return;

    let isActive = true;
    setPageData(null);

    let request;
    if (cmsPageViewInflight.has(pageType)) {
      request = cmsPageViewInflight.get(pageType);
    } else {
      request = track().finally(() => {
        setTimeout(() => cmsPageViewInflight.delete(pageType), 300);
      });
      cmsPageViewInflight.set(pageType, request);
    }

    request.then((response) => {
      if (isActive && response?.success) {
        setPageData(response.data);
      }
    }).catch(() => {});

    return () => {
      isActive = false;
    };
  }, [pageType]);

  return pageData;
}
